<script lang="ts">
	import { Splide, SplideSlide } from '@splidejs/svelte-splide';
	import '@splidejs/svelte-splide/css';
	import { onMount } from 'svelte';
	import type { PageServerData } from './$types';
	import Navbar from '$lib/components/navigation/Navbar.svelte';
	import Footer from '$lib/components/navigation/Footer.svelte';
	export let data: PageServerData;
	let information = data?.information;
	let room = data?.room;
	let detail = data?.detail;

	onMount(() => {
		const script = document.createElement('script');
		script.src = 'https://unpkg.com/@phosphor-icons/web';
		script.async = true;
		document.head.appendChild(script);
	});
</script>

<svelte:head>
	<title>Detail Room Villa - Trans Resort Bali</title>
</svelte:head>
<Navbar data={information} />
<section
	class="relative bg-cover bg-center aspect-[4/5] bg-black/30 bg-blend-overlay lg:aspect-[4/2] lg:!aspect-auto lg:h-screen"
	style="background-image: url('{detail?.images[0]?.path}');"
>
	<div class="mx-auto max-w-2xl text-center h-full flex items-center justify-center">
		<h2 class="text-3xl text-white Elmessiri md:text-5xl lg:text-6xl uppercase">{detail?.name}</h2>
	</div>
	<div class="hidden absolute w-full bg-mindidarkblue z-10 bottom-10 left-0 px-8 lg:block"></div>
</section>
<section class="py-10 md:py-16 lg:py-24">
	<div class="mx-auto max-w-screen-2xl px-6 lg:grid lg:grid-cols-2 md:px-10 lg:gap-x-28 lg:px-32">
		<div>
			<h2 class="Elmessiri font-bold text-[#7D704F] text-3xl md:text-3xl lg:text-5xl">
				{detail?.name}
			</h2>
			<ul class="mt-6 flex flex-wrap items-center gap-2">
				<li
					class="flex items-center space-x-3 bg-mindibackgroundcolor text-[#7D704F] rounded-md px-4 py-2.5 text-sm"
				>
					<svg
						class="w-6 h-6 fill-[#7D704F]"
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						fill="#000000"
						viewBox="0 0 256 256"
						><path
							d="M214,48V96a6,6,0,0,1-12,0V62.48l-53.76,53.76a6,6,0,0,1-8.48-8.48L193.52,54H160a6,6,0,0,1,0-12h48A6,6,0,0,1,214,48ZM107.76,139.76,54,193.52V160a6,6,0,0,0-12,0v48a6,6,0,0,0,6,6H96a6,6,0,0,0,0-12H62.48l53.76-53.76a6,6,0,0,0-8.48-8.48Z"
						></path></svg
					>
					<span class="inline-block">{detail?.size}</span>
				</li>
				<li
					class="flex items-center space-x-3 bg-mindibackgroundcolor text-[#7D704F] rounded-md px-4 py-2.5 text-sm"
				>
					<svg
						class="w-6 h-6 fill-[#7D704F]"
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						fill="#000000"
						viewBox="0 0 256 256"
						><path
							d="M216,74H30V48a6,6,0,0,0-12,0V208a6,6,0,0,0,12,0V174H242v34a6,6,0,0,0,12,0V112A38,38,0,0,0,216,74ZM30,86h76v76H30Zm88,76V86h98a26,26,0,0,1,26,26v50Z"
						></path></svg
					>
					<span class="inline-block">{detail?.type}</span>
				</li>
				<li
					class="flex items-center space-x-3 bg-mindibackgroundcolor text-[#7D704F] rounded-md px-4 py-2.5 text-sm"
				>
					<svg
						class="w-6 h-6 fill-[#7D704F]"
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						fill="#000000"
						viewBox="0 0 256 256"
						><path
							d="M112.6,158.43a58,58,0,1,0-57.2,0A93.83,93.83,0,0,0,5.21,196.72a6,6,0,0,0,10.05,6.56,82,82,0,0,1,137.48,0,6,6,0,0,0,10-6.56A93.83,93.83,0,0,0,112.6,158.43ZM38,108a46,46,0,1,1,46,46A46.06,46.06,0,0,1,38,108Zm211,97a6,6,0,0,1-8.3-1.74A81.8,81.8,0,0,0,172,166a6,6,0,0,1,0-12,46,46,0,1,0-17.08-88.73,6,6,0,1,1-4.46-11.14,58,58,0,0,1,50.14,104.3,93.83,93.83,0,0,1,50.19,38.29A6,6,0,0,1,249,205Z"
						></path></svg
					>
					<span class="inline-block">{detail?.occupancy}</span>
				</li>
				<li
					class="flex items-center space-x-3 bg-mindibackgroundcolor text-[#7D704F] rounded-md px-4 py-2.5 text-sm"
				>
					<svg
						class="w-6 h-6 fill-[#7D704F]"
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						fill="#000000"
						viewBox="0 0 256 256"
						><path
							d="M88,147.39a6,6,0,0,0,6-6V126h68v17.29a6,6,0,0,0,12,0V32a6,6,0,0,0-12,0V50H94V32a6,6,0,0,0-12,0V141.39A6,6,0,0,0,88,147.39ZM94,114V94h68v20Zm68-52V82H94V62ZM26,168a6,6,0,0,1,6-6c13.82,0,21,4.79,27.33,9,5.63,3.75,10.48,7,20.67,7s15-3.24,20.67-7c6.33-4.22,13.51-9,27.32-9s21,4.79,27.33,9c5.63,3.75,10.49,7,20.68,7s15-3.24,20.67-7c6.33-4.22,13.51-9,27.33-9a6,6,0,0,1,0,12c-10.18,0-15,3.24-20.67,7-6.34,4.22-13.52,9-27.33,9s-21-4.79-27.33-9c-5.63-3.75-10.49-7-20.68-7s-15,3.24-20.67,7c-6.33,4.22-13.51,9-27.32,9s-21-4.79-27.33-9C47,177.24,42.18,174,32,174A6,6,0,0,1,26,168Zm204,40a6,6,0,0,1-6,6c-10.18,0-15,3.24-20.67,7-6.34,4.22-13.52,9-27.33,9s-21-4.79-27.33-9c-5.63-3.75-10.49-7-20.68-7s-15,3.24-20.67,7c-6.33,4.22-13.51,9-27.32,9s-21-4.79-27.33-9C47,217.24,42.18,214,32,214a6,6,0,0,1,0-12c13.82,0,21,4.79,27.33,9,5.63,3.75,10.48,7,20.67,7s15-3.24,20.67-7c6.33-4.22,13.51-9,27.32-9s21,4.79,27.33,9c5.63,3.75,10.49,7,20.68,7s15-3.24,20.67-7c6.33-4.22,13.51-9,27.33-9A6,6,0,0,1,230,208Z"
						></path></svg
					>
					<span class="inline-block">{detail?.view}</span>
				</li>
			</ul>
		</div>
		<div class="mt-8 lg:mt-16">
			<div class="text-[#514641]">
				{@html detail?.description}
			</div>
			<div class="flex items-start gap-3 mt-3 flex-col lg:flex-row">
				<a
					class="btn-primary-border px-5 py-3 w-full lg:w-fit text-center"
					target="_blank"
					href="https://geckodigital.co/vt/Trans/">Virtual Tour</a
				>
				<a class="btn-primary px-5 py-3 w-full lg:w-fit text-center" href={detail?.url}>Book Now</a>
			</div>
		</div>
	</div>
</section>
<section
	class="bg-cover bg-center bg-blend-overlay bg-black/60 py-20 lg:py-32"
	style="background-image: url({detail?.images[0]?.path});"
>
	<div class="mx-auto px-6 lg:px-10">
		<h1 class="text-3xl Elmessiri text-white text-center md:text-4xl lg:text-5xl">Services</h1>
		<div class="flex lg:hidden items-start flex-wrap gap-4 justify-center mt-5">
			<div class="text-white flex items-center gap-4">
				<svg
					class="w-8 h-8 fill-white shrink-0 lg:w-14 lg:h-14"
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					fill="#000000"
					viewBox="0 0 256 256"
					><path
						d="M240.37,172.8,138,96l25.59-19.2A6,6,0,0,0,166,72a38,38,0,1,0-76,0,6,6,0,0,0,12,0,26,26,0,0,1,51.82-2.88l-29.32,22-.21.16L15.63,172.8A14,14,0,0,0,24,198H232a14,14,0,0,0,8.39-25.2Zm-6.5,11.83A1.85,1.85,0,0,1,232,186H24a2,2,0,0,1-1.19-3.6L128,103.5l105.17,78.9A1.85,1.85,0,0,1,233.87,184.63Z"
					></path></svg
				>
				<span class="lg:text-center lg:block lg:mt-4"> Laundry / Pressing </span>
			</div>
			<div class="text-white flex items-center gap-4">
				<svg
					class="w-8 h-8 fill-white shrink-0 lg:w-14 lg:h-14"
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					fill="#000000"
					viewBox="0 0 256 256"
					><path
						d="M74,88V40a6,6,0,0,1,12,0V88a6,6,0,0,1-12,0ZM214,40V224a6,6,0,0,1-12,0V174H152a6,6,0,0,1-6-6c0-4.41.68-108.25,59.64-133.51A6,6,0,0,1,214,40ZM202,50c-36.79,24.29-42.82,91.48-43.81,112H202ZM117.92,39a6,6,0,1,0-11.84,2L114,88.48a34,34,0,0,1-68,0L53.92,41a6,6,0,0,0-11.84-2l-8,48A6.61,6.61,0,0,0,34,88a46.06,46.06,0,0,0,40,45.6V224a6,6,0,0,0,12,0V133.6A46.06,46.06,0,0,0,126,88a6.61,6.61,0,0,0-.08-1Z"
					></path></svg
				>
				<span class="lg:text-center lg:block lg:mt-4"> in-room dining </span>
			</div>
			<div class="text-white flex items-center gap-4">
				<svg
					class="w-8 h-8 fill-white shrink-0 lg:w-14 lg:h-14"
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					fill="#000000"
					viewBox="0 0 256 256"
					><path
						d="M172,74a74.41,74.41,0,0,0-14.17,1.36,70,70,0,0,0-54.11-63.59A6,6,0,0,0,96.53,19,58.06,58.06,0,0,1,27,88.53a6,6,0,0,0-7.19,7.19,70.22,70.22,0,0,0,33.3,44.95A50,50,0,0,0,92,222h80a74,74,0,0,0,0-148ZM34.22,101.76Q37.1,102,40,102a70.08,70.08,0,0,0,70-70c0-1.94-.08-3.88-.24-5.8A57.64,57.64,0,0,1,146,78.71,74.32,74.32,0,0,0,102.2,123,50.36,50.36,0,0,0,92,122a49.74,49.74,0,0,0-29.86,9.92A58.24,58.24,0,0,1,34.22,101.76ZM172,210H92a38,38,0,1,1,7.08-75.34,75.84,75.84,0,0,0-1.07,9,6,6,0,0,0,12,.7,61.54,61.54,0,0,1,2-12.24c0-.15.08-.29.11-.43A62.06,62.06,0,1,1,172,210Z"
					></path></svg
				>
				<span class="lg:text-center lg:block lg:mt-4"> Turndown Service </span>
			</div>
			<div class="text-white flex items-center gap-4">
				<svg
					class="w-8 h-8 fill-white shrink-0 lg:w-14 lg:h-14"
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					fill="#000000"
					viewBox="0 0 256 256"
					><path
						d="M128,42a94,94,0,1,0,94,94A94.11,94.11,0,0,0,128,42Zm0,176a82,82,0,1,1,82-82A82.1,82.1,0,0,1,128,218ZM60.24,36.24l-32,32a6,6,0,1,1-8.48-8.48l32-32a6,6,0,1,1,8.48,8.48Zm176,32a6,6,0,0,1-8.48,0l-32-32a6,6,0,0,1,8.48-8.48l32,32A6,6,0,0,1,236.24,68.24ZM184,130a6,6,0,0,1,0,12H128a6,6,0,0,1-6-6V80a6,6,0,0,1,12,0v50Z"
					></path></svg
				>
				<span class="lg:text-center lg:block lg:mt-4">
					STAR – 24 hour one button press service
				</span>
			</div>
			{#if detail.slug === 'club-premier'}
				<div class="text-white flex items-center gap-4">
					<svg
						class="w-8 h-8 fill-white shrink-0 lg:w-14 lg:h-14"
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						fill="#000000"
						viewBox="0 0 256 256"
						><path
							d="M205.33,103.67,183.56,29.74A8,8,0,0,0,175.89,24H80.11a8,8,0,0,0-7.67,5.74L50.67,103.67a63.46,63.46,0,0,0,17.42,64.67A87.39,87.39,0,0,0,120,191.63V232H88a8,8,0,1,0,0,16h80a8,8,0,1,0,0-16H136V191.63a87.41,87.41,0,0,0,51.91-23.29A63.46,63.46,0,0,0,205.33,103.67ZM86.09,40h83.82L190,108.19c.09.3.17.6.25.9-21.42,7.68-45.54-1.6-58.63-8.23C106.43,88.11,86.43,86.49,71.68,88.93ZM177,156.65a71.69,71.69,0,0,1-98,0,47.55,47.55,0,0,1-13-48.46l.45-1.52c12-4.06,31.07-5.14,57.93,8.47,11.15,5.65,29.16,12.85,48.43,12.85a68.64,68.64,0,0,0,19.05-2.6A47.2,47.2,0,0,1,177,156.65Z"
						></path></svg
					>

					<span class="lg:text-center lg:block lg:mt-4"> Club Access Benefit </span>
				</div>
			{/if}
		</div>
		<ul class="mt-6 space-y-2 hidden lg:flex flex-wrap justify-center lg:mx-auto lg:mt-10">
			<li class="text-white flex items-center space-x-3 px-5 lg:flex-col">
				<svg
					class="w-8 h-8 fill-white shrink-0 lg:w-14 lg:h-14"
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					fill="#000000"
					viewBox="0 0 256 256"
					><path
						d="M240.37,172.8,138,96l25.59-19.2A6,6,0,0,0,166,72a38,38,0,1,0-76,0,6,6,0,0,0,12,0,26,26,0,0,1,51.82-2.88l-29.32,22-.21.16L15.63,172.8A14,14,0,0,0,24,198H232a14,14,0,0,0,8.39-25.2Zm-6.5,11.83A1.85,1.85,0,0,1,232,186H24a2,2,0,0,1-1.19-3.6L128,103.5l105.17,78.9A1.85,1.85,0,0,1,233.87,184.63Z"
					></path></svg
				>
				<span class="lg:text-center lg:block lg:mt-4"> Laundry / Pressing </span>
			</li>
			<li class="text-white flex items-center space-x-3 px-5 lg:flex-col">
				<svg
					class="w-8 h-8 fill-white shrink-0 lg:w-14 lg:h-14"
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					fill="#000000"
					viewBox="0 0 256 256"
					><path
						d="M74,88V40a6,6,0,0,1,12,0V88a6,6,0,0,1-12,0ZM214,40V224a6,6,0,0,1-12,0V174H152a6,6,0,0,1-6-6c0-4.41.68-108.25,59.64-133.51A6,6,0,0,1,214,40ZM202,50c-36.79,24.29-42.82,91.48-43.81,112H202ZM117.92,39a6,6,0,1,0-11.84,2L114,88.48a34,34,0,0,1-68,0L53.92,41a6,6,0,0,0-11.84-2l-8,48A6.61,6.61,0,0,0,34,88a46.06,46.06,0,0,0,40,45.6V224a6,6,0,0,0,12,0V133.6A46.06,46.06,0,0,0,126,88a6.61,6.61,0,0,0-.08-1Z"
					></path></svg
				>
				<span class="lg:text-center lg:block lg:mt-4"> in-room dining </span>
			</li>
			<li class="text-white flex items-center space-x-3 px-5 lg:flex-col">
				<svg
					class="w-8 h-8 fill-white shrink-0 lg:w-14 lg:h-14"
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					fill="#000000"
					viewBox="0 0 256 256"
					><path
						d="M172,74a74.41,74.41,0,0,0-14.17,1.36,70,70,0,0,0-54.11-63.59A6,6,0,0,0,96.53,19,58.06,58.06,0,0,1,27,88.53a6,6,0,0,0-7.19,7.19,70.22,70.22,0,0,0,33.3,44.95A50,50,0,0,0,92,222h80a74,74,0,0,0,0-148ZM34.22,101.76Q37.1,102,40,102a70.08,70.08,0,0,0,70-70c0-1.94-.08-3.88-.24-5.8A57.64,57.64,0,0,1,146,78.71,74.32,74.32,0,0,0,102.2,123,50.36,50.36,0,0,0,92,122a49.74,49.74,0,0,0-29.86,9.92A58.24,58.24,0,0,1,34.22,101.76ZM172,210H92a38,38,0,1,1,7.08-75.34,75.84,75.84,0,0,0-1.07,9,6,6,0,0,0,12,.7,61.54,61.54,0,0,1,2-12.24c0-.15.08-.29.11-.43A62.06,62.06,0,1,1,172,210Z"
					></path></svg
				>
				<span class="lg:text-center lg:block lg:mt-4"> Turndown Service </span>
			</li>
			<li class="text-white flex items-center space-x-3 px-5 lg:flex-col">
				<svg
					class="w-8 h-8 fill-white shrink-0 lg:w-14 lg:h-14"
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					fill="#000000"
					viewBox="0 0 256 256"
					><path
						d="M128,42a94,94,0,1,0,94,94A94.11,94.11,0,0,0,128,42Zm0,176a82,82,0,1,1,82-82A82.1,82.1,0,0,1,128,218ZM60.24,36.24l-32,32a6,6,0,1,1-8.48-8.48l32-32a6,6,0,1,1,8.48,8.48Zm176,32a6,6,0,0,1-8.48,0l-32-32a6,6,0,0,1,8.48-8.48l32,32A6,6,0,0,1,236.24,68.24ZM184,130a6,6,0,0,1,0,12H128a6,6,0,0,1-6-6V80a6,6,0,0,1,12,0v50Z"
					></path></svg
				>
				<span class="lg:text-center lg:block lg:mt-4">
					STAR – 24 hour one button press service
				</span>
			</li>
			{#if detail.slug === 'club-premier'}
				<li class="text-white flex items-center space-x-3 px-5 lg:flex-col">
					<svg
						class="w-8 h-8 fill-white shrink-0 lg:w-14 lg:h-14"
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						fill="#000000"
						viewBox="0 0 256 256"
						><path
							d="M205.33,103.67,183.56,29.74A8,8,0,0,0,175.89,24H80.11a8,8,0,0,0-7.67,5.74L50.67,103.67a63.46,63.46,0,0,0,17.42,64.67A87.39,87.39,0,0,0,120,191.63V232H88a8,8,0,1,0,0,16h80a8,8,0,1,0,0-16H136V191.63a87.41,87.41,0,0,0,51.91-23.29A63.46,63.46,0,0,0,205.33,103.67ZM86.09,40h83.82L190,108.19c.09.3.17.6.25.9-21.42,7.68-45.54-1.6-58.63-8.23C106.43,88.11,86.43,86.49,71.68,88.93ZM177,156.65a71.69,71.69,0,0,1-98,0,47.55,47.55,0,0,1-13-48.46l.45-1.52c12-4.06,31.07-5.14,57.93,8.47,11.15,5.65,29.16,12.85,48.43,12.85a68.64,68.64,0,0,0,19.05-2.6A47.2,47.2,0,0,1,177,156.65Z"
						></path></svg
					>

					<span class="lg:text-center lg:block lg:mt-4"> Club Access Benefit </span>
				</li>
			{/if}
		</ul>
	</div>
</section>
<section class="py-0 md:py-16 lg:py-32">
	<div class="mx-auto max-w-screen-xl px-6">
		<div class="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-20">
			<div
				class="bg-cover bg-center rounded-xl col-span-2"
				style="background-image: url({detail?.images[1]?.path});"
			></div>
			<!-- <div class="col-span-3 py-20">
				<h2 class="Elmessiri font-bold text-[#7D704F] text-3xl lg:text-3xl lg:text-4xl">
					Room Facilities
				</h2>
				<ul
					class="mt-10 text-[#514641] list-none ml-0 space-y-1.5 mx-auto grid grid-cols-2 gap-x-12"
				>
				{#each detail.facilities as item}
				<li class="flex items-center space-x-3 border-b pt-2 pb-3">
					<i class="ph-light {item?.icon} text-xl"></i>
					<span>{item?.item}</span>
				</li>
				{/each}
				</ul>
			</div> -->
			<div class="col-span-3 py-0 lg:py-20">
				<h2 class="Elmessiri font-bold text-[#7D704F] text-3xl md:text-3xl lg:text-4xl">
					Room Facilities
				</h2>
				<ul
					class="mt-10 text-[#514641] list-none ml-0 space-y-1.5 mx-auto grid grid-cols-1 lg:grid-cols-2 gap-x-12"
				>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-wifi-high text-xl"></i> <span> Wireless Internet</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-armchair text-xl"></i> <span>Sofa / lounge chairs</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-desk text-xl"></i> <span> Work / Writing Desk</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-sun text-xl"></i>
						<span>Balcony with daybed and private jacuzzi</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-shower text-xl"></i> <span>Shower - separate</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-phone text-xl"></i> <span>Telephone</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-television-simple text-xl"></i>
						<span>TV - cable / satellite</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-snowflake text-xl"></i> <span>Air Conditioning</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-stool text-xl"></i> <span>Mini Bar</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-bathtub text-xl"></i> <span>Bathtub with Shower</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-cigarette text-xl"></i>
						<span>Non-smoking / Room with Smoking Balcony</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-door text-xl"></i> <span>Interconnecting rooms available</span>
					</li>
				</ul>
			</div>
		</div>

		<div class="grid grid-cols-1 lg:grid-cols-5 gap-20 mt-0 lg:mt-20">
			<div
				class="bg-cover bg-center rounded-xl col-span-2 order-2"
				style="background-image: url({detail?.images[2]?.path});"
			></div>
			<div class="col-span-3 py-10 lg:py-20 order-1">
				<h2 class="Elmessiri font-bold text-[#7D704F] text-3xl md:text-3xl lg:text-4xl">
					Room Amenities
				</h2>
				<ul
					class="mt-10 text-[#514641] list-none ml-0 space-y-1.5 mx-auto grid grid-cols-1 lg:grid-cols-2 gap-x-12"
				>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-vault text-xl"></i>
						<span>In-room safe</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-moon text-xl"></i>
						<span>Different types of pillows selection</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-hair-dryer text-xl"></i>
						<span>Hair dryer</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-alarm text-xl"></i>
						<span>Alarm Clock / Radio</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-beer-bottle text-xl"></i>
						<span>Daily mineral water</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-plug text-xl"></i>
						<span>Electricity adapters</span>
					</li>
					<li class="flex items-center space-x-3 border-b pt-2 pb-3">
						<i class="ph-light ph-coffee text-xl"></i>
						<span>Coffee &amp; Tea Making Facilities</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</section>
<section class="pb-10 md:pb-16 lg:pb-24">
	<div class="mx-auto container px-6 lg:pl-32">
		<h2 class="font-serif font-bold text-mindigold text-3xl md:text-3xl lg:text-5xl">
			Room Images
		</h2>
	</div>

	<div id="destination-card" class="2xl:container 2xl:mx-auto mt-6 mx-6 lg:mt-14 lg:mx-0">
		<Splide
			options={{
				rewind: false,
				gap: 5,
				type: 'slide',
				arrows: true,
				padding: { right: '15%', left: '5%' },
				pagination: false,
				breakpoints: {
					1024: {
						perPage: 2,
						padding: { right: '10%', left: '5%' }
					},

					768: {
						perPage: 1,
						padding: { right: '15%', left: '5%' },
						arrows: false,
						pagination: true
					}
				}
			}}
		>
			{#each detail?.images as img}
				<SplideSlide>
					<div class="h-[20rem] lg:h-[30rem] w-full rounded-xl overflow-hidden md:aspect-video">
						<img
							class="object-cover object-center w-full h-full"
							alt={detail?.name}
							src={img?.path}
						/>
					</div>
				</SplideSlide>
			{/each}
		</Splide>
	</div>
</section>
<Footer data={information} />
